import React from "react";

import {
  InterlinkingBlockStyle,
  InterlinkingBlockWrap,
  Link,
  LinkItem,
  LinksContainer,
  Section,
  SectionContainer,
  SectionTitle,
} from "./InterlinkingBlock.style";
import { InterlinkingBlockProps } from "./type";

const InterlinkingBlock: React.FC<InterlinkingBlockProps> = ({
  interlinkingBlock = [],
}) => {
  if (!interlinkingBlock || interlinkingBlock.length === 0) {
    return null;
  }

  return (
    <InterlinkingBlockStyle>
      <InterlinkingBlockWrap>
        <SectionContainer>
          {interlinkingBlock?.map((section, sectionIndex) => (
            <Section
              key={`section-${sectionIndex}`}
              className={`${sectionIndex}`}
            >
              <SectionTitle>{section?.title}</SectionTitle>
              <LinksContainer>
                {section?.links?.map((link, linkIndex) => (
                  <LinkItem key={`link-${sectionIndex}-${linkIndex}`}>
                    <Link
                      href={link?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.title}
                    </Link>
                  </LinkItem>
                ))}
              </LinksContainer>
            </Section>
          ))}
        </SectionContainer>
      </InterlinkingBlockWrap>
    </InterlinkingBlockStyle>
  );
};

export default InterlinkingBlock;
